module.exports = __webpack_public_path__ + "media/images/pc/page_common/sola_header_bg-5269761d351dfbd932410f80275c3263.png";